import { Directive, OnDestroy, OnInit, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[uppercase]',
})
export class UppercaseDirective implements OnInit, OnDestroy {
  private sub = new Subscription();

  constructor(@Optional() private ngControl: NgControl) {}

  ngOnInit(): void {
    const control = this.ngControl?.control;
    if (!control) return;

    this.sub.add(
      control.valueChanges.subscribe((value) => {
        if (typeof value !== 'string') return;
        const upper = value.toUpperCase();
        if (upper !== value) {
          control.setValue(upper, { emitEvent: false });
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
